import React, { useState, useEffect } from 'react';
import { Container, Table } from 'react-bootstrap';
import { listDocumentoDatosAbiertosSitioWeb } from '@/api/municipalidadAPI';
import MunicipalidadHeader from '../components/Header/MunicipalidadHeader';
import { URL_ADJUNTOS } from '../constants/constants';
import './DocumentoDatosAbiertosView.css';

const DocumentoDatosAbiertosView = () => {
  const [datosAbiertos, setDatosAbiertos] = useState(null);

  useEffect(() => {
    listDocumentoDatosAbiertosSitioWeb()
      .then((response) => {
        setDatosAbiertos(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <>
      <MunicipalidadHeader tipo="Gobierno" title="Datos Abiertos"></MunicipalidadHeader>
      <Container className="content pagina-interna">
        <h7 className="datos-abiertos-title">
          Puede descargar los Datos Abiertos en los siguientes enlaces.
        </h7>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Nombre</th>
            </tr>
          </thead>
          <tbody>
            {datosAbiertos !== null &&
              datosAbiertos.length > 0 &&
              datosAbiertos.map((item, idx) => (
                <tr key={idx}>
                  <td>
                    <a
                      rel="noreferrer"
                      target="_blank"
                      href={URL_ADJUNTOS + '?id=' + item.documento.id}
                    >
                      {item.mesAsString + ' ' + item.anioDocumentoAsString}
                    </a>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </Container>
    </>
  );
};

export default React.memo(DocumentoDatosAbiertosView);
